export const controlBase =
  'flex h-10 w-full items-center rounded-md border border-neutral-300 bg-card px-3 text-base text-neutral-900 shadow-sm ' +
  'placeholder:text-neutral-500 sm:text-sm ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-brand-500 focus-visible:ring-offset-2 ' +
  'disabled:cursor-not-allowed disabled:opacity-50 ' +
  'aria-invalid:border-danger-line aria-invalid:focus-visible:ring-danger-line';

export const controlSm = 'h-8 px-2.5 text-sm';

export const popoverSurface =
  'z-50 rounded-md border border-neutral-200 bg-card p-1 text-sm text-neutral-900 shadow-lg';

export const optionBase =
  'relative flex min-h-10 cursor-default select-none items-center gap-2 rounded-sm py-2 pl-8 pr-2 outline-none sm:min-h-9 ' +
  'data-[highlighted]:bg-neutral-100 data-[selected=true]:bg-neutral-100 data-[disabled]:pointer-events-none data-[disabled]:opacity-50';
